import { createContext, useContext } from 'react';

// Page-level scope + the "expand a leaf to see its correlated content" state (M1.2).
// Provided once in StandardsPage and consumed by the leaf rows, so we don't thread these
// through every tree layer. Mirrors the customer Correlations feature's CorrelationsContext.
export interface StandardsContentContextValue {
  expandedContentLeaves: Set<number>;
  programId: number;
  programName: string;
  stateLabel: string | null;
  toggleContentLeaf: (standardId: number) => void;
}

const StandardsContentContext = createContext<StandardsContentContextValue>({
  expandedContentLeaves: new Set(),
  programId: 0,
  programName: '',
  stateLabel: null,
  toggleContentLeaf: () => {},
});

export const useStandardsContent = () => useContext(StandardsContentContext);

export default StandardsContentContext;
